// Ventrata panel handling
function init() {
  const ventrataPanels = document.querySelectorAll(".js-ventrata-panel");
  const script = document.createElement("script");
  const src =
    "https://cdn.checkout.ventrata.com/v3/production/ventrata-checkout.min.js";
  const apiKey = "c53cf85c-187d-446c-aeb8-e72e35a97e33";

  if (ventrataPanels.length > 0) {
    script.src = src;
    script.async = true;
    script.type = "module";
    script.dataset.config = `{
      "apiKey": "${apiKey}",
      "theme": {
        "light": {
          "primary": "#ff4b00",
          "text-primary": "#000000",
          "text-secondary": "#524e4e",
          "text-disabled": "#a6a5a5",
          "gradient-A": "#ff4b00",
          "gradient-B": "#000000",
          "backdropOpacity": 0.9
        }
      }
    }`;
    document.head.appendChild(script);
  }
}

export default { init };
